import React from 'react';

type MapPointLabelProps = {
    /** Canvas coordinates, as MapLibre reports them on a pointer event. */
    x: number;
    y: number;
    testId: string;
    children: React.ReactNode;
};

/**
 * A label pinned beside a point on a map canvas.
 *
 * `pointer-events-none` so it never steals the hover that produced it, and offset from the
 * pointer rather than under it.
 */
const MapPointLabel = ({ x, y, testId, children }: MapPointLabelProps) => (
    <div
        className='pointer-events-none absolute z-30 max-w-xs translate-x-3 translate-y-3 rounded-md border border-border bg-white/95 px-3 py-2 text-xs shadow-portfolio-summary-card backdrop-blur'
        style={{ left: `${x}px`, top: `${y}px` }}
        data-testid={testId}
        role='status'
    >
        {children}
    </div>
);

export default MapPointLabel;
